import type { Person } from '../../eventsApi/persons/person'
import type { Account } from '../accounts/account'
import type { Category } from '../categories/category'
import type { EntryTypeEnum } from '../entries/entry.enum'

export class BillEntity {
    billId: string
    companyId: string
    description: string
    createdAt: Date
    updatedAt: Date
    dueAt: Date
    paidAt?: Date
    value: number
    paidValue?: number
    status: number
    source?: string
    groupId?: string
    sourceId?: string
    invoiceId?: string
    creditDebit: EntryTypeEnum
    personId?: string
    installments: boolean
    installmentInitial?: number
    installmentNumber?: number
    installmentTotal?: number
    installmentIntervalType?: 'month' | 'week'
    person?: Person
    accountId?: string
    categoryId?: string
    account?: Account
    category?: Category
    accrualMonth?: number
    accrualYear?: number
}
